<template>
    <div class="flex_start mb-16">
        <div class="flex_start title-icon mr-12">
            <div style="height: 6px; background: #0f3b99"></div>
            <div style="height: 10px; background: #fe3f3e"></div>
        </div>
        <div class="title">{{ title }}</div>
    </div>
</template>

<script>
    export default {
        props: {
            title: { type: String, default: '' },
        },
    }
</script>
<style lang="scss" scoped>
    .title-icon {
        flex-direction: column;
        height: 16px;
        div {
            width: 3px;
        }
    }
    .title {
        font-weight: 500;
        font-size: 14px;
        font-family: PingFangSC;
        font-style: normal;
        color: #fe3f3e;
    }
</style>
